import { FilterOperators } from '@va/types/filters';
import { useState } from 'react';

export const useOperator = (initialOperator: FilterOperators) => {
  const [operator, setOperator] = useState<FilterOperators>(initialOperator);

  return { operator, setOperator };
};
